var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"box-list",attrs:{"title":"Udestående"}},[_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Flyt',
			value: 'move'
		},
		{
			label: 'Reg',
			value: 'reg'
		},
		{
			label: 'Bem',
			value: 'remark'
		}
	]},slot:"tools",model:{value:(_vm.filters.sort),callback:function ($$v) {_vm.$set(_vm.filters, "sort", $$v)},expression:"filters.sort"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Alle',
			value: 'all'
		},
		{
			label: 'Til lager',
			value: 'to'
		},
		{
			label: 'Fra lager',
			value: 'from'
		}
	]},slot:"tools",model:{value:(_vm.filters.storage),callback:function ($$v) {_vm.$set(_vm.filters, "storage", $$v)},expression:"filters.storage"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Privat',
			value: 'private'
		},
		{
			label: 'Erhverv',
			value: 'business'
		}
	]},slot:"tools",model:{value:(_vm.filters.type),callback:function ($$v) {_vm.$set(_vm.filters, "type", $$v)},expression:"filters.type"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Begrænset',
			value: false
		},
		{
			label: 'Ubegrænset',
			value: true
		}
	]},slot:"tools",model:{value:(_vm.filters.unlimited),callback:function ($$v) {_vm.$set(_vm.filters, "unlimited", $$v)},expression:"filters.unlimited"}}),_c('button-view',{staticStyle:{"display":"inline-block"},attrs:{"slot":"tools","label":"Download"},on:{"click":_vm.download},slot:"tools"}),_c('table-view',{ref:"table",attrs:{"columns":_vm.columns,"items":_vm.items},on:{"itemClick":_vm.itemClick}}),_c('new-table-view',{attrs:{"columns":_vm._columns,"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}}),_c('div',{staticClass:"status"},[_vm._v("Status: "+_vm._s(_vm._status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }